import React from 'react';
import { Box, Container, Heading, Text, VStack, HStack } from '@chakra-ui/react';
import { VideoIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { ScrollReveal } from './ScrollReveal';
interface VideoCallSectionProps {
  scheduleUrl: string;
}
export function VideoCallSection({
  scheduleUrl
}: VideoCallSectionProps) {
  return <Box as="section" className="defer-paint" position="relative" py={{
    base: 16,
    md: 24
  }} overflow="hidden" bg="#0a0a0a" data-id="element-67" data-mp="3iunfwys4nlse">
      <Box aria-hidden="true" position="absolute" inset={0} bgImage="url('https://cdn.magicpatterns.com/patterns/generated-images/40f3f42e-b3b6-4f43-9444-8836e801f7ff.jpg')" bgSize="cover" bgPosition="center" opacity={0.35} data-id="element-68" data-mp="2q5pxmvnx1ozn" />
      <Box aria-hidden="true" position="absolute" inset={0} bgGradient="linear(to-b, rgba(10,10,10,0.92), rgba(10,10,10,0.78), rgba(10,10,10,0.95))" data-id="element-69" data-mp="jbuj4d9x7k8g" />

      <Container maxW="container.md" position="relative" zIndex={2} data-id="element-70" data-mp="amnj7v04k779">
        <ScrollReveal data-id="element-71" data-mp="eohe1mnn2gzi">
          <VStack spacing={6} textAlign="center" data-id="element-72" data-mp="enpj8e1v8naa">
            <Box w={{
            base: '70px',
            md: '84px'
          }} h={{
            base: '70px',
            md: '84px'
          }} borderRadius="full" borderWidth="1px" borderColor="rgba(242, 169, 59, 0.5)" bg="rgba(242, 169, 59, 0.08)" display="flex" alignItems="center" justifyContent="center" boxShadow="0 0 40px rgba(242, 169, 59, 0.25)" data-id="element-73" data-mp="jo3sfzf7e39w">
              <Box as={VideoIcon} boxSize={{
              base: 8,
              md: 10
            }} color="gold.400" data-id="element-74" data-mp="5pdtsfcqjvjf" />
            </Box>

            <HStack spacing={2} borderWidth="1px" borderColor="rgba(37, 211, 102, 0.4)" bg="rgba(37, 211, 102, 0.08)" borderRadius="full" px={4} py={1.5} data-id="element-75" data-mp="34daykgc25ids">
              <Box w="8px" h="8px" borderRadius="full" bg="#25D366" boxShadow="0 0 10px rgba(37, 211, 102, 0.9)" data-id="element-76" data-mp="2xbe61thll40z" />
              <Text fontSize="xs" color="#5ee79a" fontWeight="semibold" data-id="element-77" data-mp="362y38b6l75tu">
                Atención en vivo
              </Text>
            </HStack>

            <Heading as="h2" fontSize={{
            base: '2xl',
            md: '4xl'
          }} color="white" fontWeight="black" lineHeight="1.2" textShadow="0 0 30px rgba(232, 99, 26, 0.35)" data-id="element-78" data-mp="2ie5cct4tno63">
              Recibe tu Consulta por Videollamada
            </Heading>

            <Text fontSize={{
            base: 'md',
            md: 'lg'
          }} color="gray.300" maxW="560px" lineHeight="tall" data-id="element-79" data-mp="7kiyhin8huyr">
              Habla directamente con nuestro especialista desde la comodidad de
              tu hogar.
            </Text>

            <CTAButton href={scheduleUrl} w={{
            base: 'full',
            sm: 'auto'
          }} maxW="420px" px={12} mt={2} data-id="element-80" data-mp="1bjo1hj0dqucj">
              Agendar Videollamada
            </CTAButton>
          </VStack>
        </ScrollReveal>
      </Container>
    </Box>;
}